module.exports = __webpack_public_path__ + "img/bank-payment.b4f59f3c.svg";